// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1qFdi","calendarButtons":"ClockData_calendarButtons__flcXq"};